import { LinkButton, type LinkButtonProps, LinkType } from "../../../common/components/Link";
import { Icon } from "../../../common/components/icon/Icon";
import { type IconType } from "../../../common/components/icon/IconType";
import { IconSize } from "../../../common/components/icon/IconSize";
import { forwardRef } from "react";
import classNames from "classnames";

interface Props extends Omit<LinkButtonProps, "children"> {
  icon: IconType;
  active?: boolean;
}

export const MobileNavButton = forwardRef<HTMLButtonElement, Props>(({ active, icon, className, ...rest }, ref) => {
  return (
    <LinkButton
      className={classNames("scha__mobile-navigation__button", className)}
      variant={active ? LinkType.PRIMARY : LinkType.NAVIGATION}
      ref={ref}
      {...rest}
    >
      <Icon type={icon} size={IconSize.FONT_20} />
    </LinkButton>
  );
});
